<template>
  <div class="picture-audit-container">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box flex-3">
          <div class="search-wrap">
            <div class="block">
              <div class="control">
                <label class="label inline-block">动态状态</label>
                <label class="inline-block">
                  <input type="checkbox" value="1" v-model="search.status">已放行
                </label>
                <label class="inline-block wait-verify">
                  <input type="checkbox" value="0" v-model="search.status">待放行
                  <span v-if="statusCount && statusCount[0]" class="num-icon">{{statusCount[0]}}</span>
                </label>
                <label class="inline-block">
                  <input type="checkbox" value="3" v-model="search.status">回收站
                </label>
            </div>
            <div class="control">
              <label class="label inline-block r-top">动态放行时间</label>
              <span class="inline-block">
                <el-date-picker
                  v-model="search.startTime"
                  type="datetime"
                  placeholder="放行开始时间"
                  align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                  v-model="search.endTime"
                  type="datetime"
                  placeholder="放行结束时间"
                  align="right">
                </el-date-picker>
              </span>
            </div>
            <div class="control">
              <button class="button is-info" @click="doSearch">搜索</button>
            </div>
          </div>
          </div>
        </article>
      </div>
      <div class="clearfix">
        <span>
          <label class="label inline-block" style="font-size: 18px;">
            <input type="checkbox" v-model="checkAll" @click="onCheckAll">全选
          </label>
        </span>
        <button class="button is-danger" @click="onBatchDeleteImages">批量删除图片</button>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <article class="clearfix picture-list-area">
        <div class="card-wrap" v-for="(item, index) in list" v-if="item.image" :key="index">
          <div class="score">{{item.image.score && item.image.score}}</div>
          <div class="check-wrap">
            <label class="label inline-block check-box"><input type="checkbox" v-model="item.checked" @click="onCheckOne" :disabled="item.imageStatus === 'dImages'"></label>
          </div>
              <i class="code-review fa fa-code" aria-hidden="true" @click.stop="onGoAudit(index, item.image)"></i>
            <div class="lightgallery">
              <div class="image" @click="onImagePreviewClick($event,0,item.image)">
                <image-component :image="item.image" :width="250" :height="375"></image-component>
              </div>
            </div>
          <div class="button-wrapper">
            <button v-if="item.imageStatus !== 'dImages'" class="button is-danger is-outlined  btn-width" @click="onDeleteImg(item, index)">删除</button>
            <button v-else class="button is-warning is-outlined  btn-width" @click="onRecall(item, index)">放回</button>
          </div>
        </div>
      </article>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import {getTimeByDateStr} from 'UTILS/date';
  import {onImagePreviewClick} from 'UTILS/imagePreview';

  export default {
    components:{
      
    },
    computed:{
      
    },
    data(){
      return {
        checkAll:false,
        checkCount: 0,
        checked: false,
        search:{
          status:["0"],
          startTime: '',
          endTime: '',
          page:1,
          pageSize:20,
        },
        allOpts:{
          articleTypes:[],
          bloggers:[],
          channels:[],
          topics:[]
        },
        list:[],
        count:0,
        statusCount:{},
        scrollTop:0,
        isFixed:false,
        scrollTop: 0,
      }
    },
    watch:{
      
    },
    mounted(){
      if(this.$route.query.searchParams){
        this.search = Object.assign(this.search,JSON.parse(JSON.stringify(this.$route.query.searchParams)));
      }
      this.scrollTop = this.$route.query.scrollTop ? this.$route.query.scrollTop : 0;
      this.initSearchParams();
      this.getList();
    },
    methods:{
      onImagePreviewClick:onImagePreviewClick,
      doSearch(){
        this.search.page = 1;
        this.getList();
      },
      getList(){
        this.initSearchParams();
        let params = {
          page: this.search.page,
          pageSize: this.search.pageSize,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
          status: this.search.status,
        }
        HttpRequest.get("/admin.php?method=fashion.getArticleImageList",params).then(response => {
            this.count = response.data.count;
            _.each(response.data.list, (item, index) => {
              item.checked = false;
            })
            this.list = _.toArray(response.data.list);
            setTimeout(()=>{
              this.scrollTop && window.scrollTo(0,this.scrollTop);
            },1000)
        })
      },
       // 切换分页回调事件；
      handleCurrentChange(page){
        if(this.search.page !== page){
          this.search.page = page;
          this.getList();
        }
      },
      onBatchDeleteImages() {
        let _arr = [];
        _.each(this.list, (item, index) => {
          if (item.checked) {
            _arr.push(item);
          }
        })
        let _checkedImg = {};
        _.each(_arr, (item, index) => {
          if (!_checkedImg[item.articleId]) {
            _checkedImg[item.articleId] = [item.image];
          } else if (_checkedImg[item.articleId].indexOf(item.image) < 0) {
            _checkedImg[item.articleId].push(item.image);
          }
        })
        this.dealDeleteImage(_checkedImg);
      },
      onDeleteImg(item, index) {
        let _key = item.articleId;
        let _params = {
          [_key]: item,
        }
        this.dealDeleteImage(_params, 'single');
      },
      dealDeleteImage(_params, deleteType) {
        let params = {
          images: JSON.stringify(_params),
        }
        let _message = "批量删除图片成功！";
        if (deleteType === 'single') {
          _message = "删除图片成功！";
        } 
        HttpRequest.post("/admin.php?method=fashion.deleteArticleImage",params).then(response => {
          if (response.data.success) {
            this.$message(_message);
            this.getList();
          }
        })
      },
      onRecall(item, index) {
        item = JSON.parse(JSON.stringify(item))
        let _params = {
          dImages: item,
          articleId: item.articleId,
        }
        _params = JSON.parse(JSON.stringify(_params));
        HttpRequest.get("/admin.php?method=fashion.dealArticleImages",_params).then(response => {
          if (response.data) {
            this.$message("操作成功")
            this.getList();
          }
        })
      },
      onCheckAll(){
        let _filterCheck = []
        setTimeout(()=>{
          if(this.checkAll){
            _.each(this.list,item => {
              if (item.imageStatus !== 'dImages') {
                item.checked = true;
                _filterCheck.push(item);
              }
            })
            this.checkCount = _filterCheck.length;
          }else {
            _.each(this.list,item => {
              item.checked = false
            })
            this.checkCount = 0
          }
        },0)
      },
      onCheckOne(){
        setTimeout(()=>{
          let checkCount = 0
          let _filterCheck = [];
          _.each(this.list,item => {
            if(item.checked){
              checkCount++;
            }
            if (item.imageStatus !== 'dImages') {
              _filterCheck.push(item);
            }
          })
          this.checkCount = checkCount
          

          if(checkCount !== _filterCheck.length){
            this.checkAll = false
          }else{
            this.checkAll = true
          }
        },0)
      },
      initSearchParams(){
        if(this.search.startTime || this.search.endTime){
          this.search.startTime = getTimeByDateStr(this.search.startTime);
          this.search.endTime = getTimeByDateStr(this.search.endTime);
        }else {
          this.search.startTime = "";
          this.search.endTime = "";
        }
      },
      onGoAudit(_index, _params) {
        let scrollTop = $(document).scrollTop();
        this.$router.push({
          name: 'pictureSettings',
          query: {
            fromWhere: 'audit',
            image: _params.image,
            score: _params.score,
            scrollTop:scrollTop,
            searchParams: this.search,
          }
        })
      },
    },
    destroyed(){
      $(document).off("scroll",this.scrollHandler)
    },
  }
</script>
<style lang="less">
  .list-wrap {
    .is-parent {
      .flex-1 {
        flex-grow: 1;
      }
      .flex-3 {
        flex-grow: 3;
      }
      .flex-space {
        flex-basis: 20px;
      }
      .is-child {
        .search-wrap {
          .block {
            label {
              margin-left: 10px;
            }
          }
          .num-icon {
            display: inline-block;
            padding: 0 3px;
            height:15px;
            background-color: #ed6c63;
            color:#fff;
            border-radius: 15px;
            font-size: 12px;
            text-align: center;
            line-height: 15px;
          }
        }
        .data-wrap {
          display: flex;
          flex-wrap: wrap;
          width: 400px;
          .data-item {
            width:50%;
            margin-top: 20px;
          }
        }
      }
      .set-container {
        display: flex;
        justify-content: space-between;
        .switch-bar {
          display: inline-block;
          margin-top: 5px;
          margin-left: 10px;
        }
      }
    }
    .article-list {
      margin-left: 10px;
    }
    .hide {
      visibility: hidden;
    }
    .fixed {
      position: fixed;
      top:53px;
      left:220px;
      z-index: 1025;
    }
    .picture-list-area {
      margin-top: 20px;
    }
    .card-wrap {
      position: relative;
      padding: 20px;
      box-sizing: border-box;
      border: 1px solid #d3d6db;
      border-radius: 6px;
      background-color: #fff;
      margin-bottom: 20px;
      margin-right: 10px;
      float: left;
    }
    .button-wrapper {
      margin-top: 15px;
      text-align: center;
    }
    .score {
      position: absolute;
      line-height: 22px;
      text-align: center;
      /*border-radius: 100%;*/
      background: rgba(0,0,0,.7);
      font-size: 22px;
      font-weight: bold;
      color:#fff;
      z-index:1;
      cursor: pointer;
    }
    .check-wrap {
      position: absolute;
      z-index: 1;
      margin-left: -16px;
      margin-top: -20px;
      .check-box {
        input[type="checkbox"] {
          width: 20px !important;
          height: 20px !important;
        }
      }
    }
    .code-review {
      position: absolute;
      top:0;
      right:0;
      z-index: 1;
      color:rgba(0,0,0,.5);
      cursor: pointer;
    }
  }
</style>
